<template>
  <div class="space-y-4">
    <div class="text-xl font-semibold">Camera Bookmarks</div>
    <div class="mx-auto">
      <DButton severity="primary" class="w-full" size="small" @click="createNew"
        ><div class="flex items-center justify-center gap-2 text-base">
          <Plus size="14" />
          <div>Create New</div>
        </div></DButton
      >
    </div>

    <div class="mt-4">
      <BookmarkItem
        v-for="bookmark in filteredViewPoints"
        :key="bookmark.id"
        :item="bookmark"
        @contextmenu="showBookmarkContext($event, bookmark.code)"
        @click="handleClickBookmark(bookmark)" />

      <div v-if="filteredViewPoints.length === 0" class="flex items-center justify-center text-gray-700">
        No Bookmarks
      </div>
    </div>
  </div>

  <DContextMenu2 ref="bookmarkMenuRef" :model="bookmarkitems" />
</template>
<script setup>
import { BookmarkItem } from '@/components';
import { DButton, DContextMenu2, useConfirm, useToast } from '@disguise/cloud-ui';
import { computed, ref } from 'vue';

import { useNodeManager } from '@/composables/useNodeManager';
import { useCruxModuleStore } from '@/stores/api/cruxmodules';
import { cameraControls } from '@/threejs/core';
import { Plus } from 'lucide-vue-next';

const { removeNode } = useNodeManager();

const cruxModuleStore = useCruxModuleStore();
const currentBookmarkId = ref(null);
const bookmarkMenuRef = ref(null);

const { confirmDialog } = useConfirm();
const toast = useToast();

const filteredViewPoints = computed(() => {
  return cruxModuleStore.cruxModules.filter((module) => module.type === 'camera_bookmark') || [];
});

const handleClickBookmark = (bookmark) => {
  updatedBookmark({ data: bookmark });
};

const updatedBookmark = (data) => {
  let bookmark = data.data;

  cameraControls.setTarget(bookmark.data.target.x, bookmark.data.target.y, bookmark.data.target.z, true);
  cameraControls.setPosition(bookmark.data.position.x, bookmark.data.position.y, bookmark.data.position.z, true);

  cameraControls.zoomTo(bookmark.data.fov / 100, true);
};

const bookmarkitems = ref([
  {
    label: 'Edit',
    icon: 'pi pi-pencil',
    command: () => {},
  },
  {
    label: 'Set as Default',
    icon: 'pi pi-check',
    command: () => {},
  },
  {
    label: 'Delete',
    icon: 'pi pi-trash',
    command: () => {
      confirmDialog('Confirmation', 'Are you sure you want to delete this bookmark?', 'Delete', 'Cancel')
        .then((response) => {
          if (response) {
            return removeNode(currentBookmarkId.value);
          }
        })
        .catch((err) => {
          console.error('Error deleting bookmark:', err);
          toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to delete bookmark',
            group: 'br',
            life: 5000,
          });
        });
    },
  },
]);

const showBookmarkContext = ($event, bookmarkId) => {
  currentBookmarkId.value = bookmarkId;
  bookmarkMenuRef.value.show($event);
};

const createNew = () => {
  cruxModuleStore.addSceneModule(null, 'camera_bookmark', {
    code: crypto.randomUUID(),
    position: {
      x: cameraControls.camera.position.x,
      y: cameraControls.camera.position.y,
      z: cameraControls.camera.position.z,
    },
    target: {
      x: cameraControls._target.x,
      y: cameraControls._target.y,
      z: cameraControls._target.z,
    },
    fov: cameraControls._zoom0 * 100,
  });
};
</script>
